var exports = {
  "tB": "ContextMenu.module__backdrop___cy14N3",
  "D8": "ContextMenu.module__contextMenuPositioner___cy14N3",
  "He": "ContextMenu.module__contextMenu___cy14N3",
  "KY": "ContextMenu.module__menuScroller___cy14N3",
  "NC": "ContextMenu.module__menuScrollerContent___cy14N3",
  "AS": "ContextMenu.module__item___cy14N3",
  "r9": "ContextMenu.module__disabled___cy14N3",
  "OR": "ContextMenu.module__danger___cy14N3",
  "Fx": "ContextMenu.module__itemIcon___cy14N3",
  "IR": "ContextMenu.module__itemLabel___cy14N3",
  "Ah": "ContextMenu.module__itemWithShortcut___cy14N3",
  "g$": "ContextMenu.module__itemShortcut___cy14N3",
  "ED": "ContextMenu.module__itemShortcutHidden___cy14N3",
  "dP": "ContextMenu.module__itemLabelContainer___cy14N3",
  "b": "ContextMenu.module__itemLabelText___cy14N3",
  "Lo": "ContextMenu.module__itemHint___cy14N3",
  "fV": "ContextMenu.module__submenuCaret___cy14N3",
  "me": "ContextMenu.module__separator___cy14N3",
  "Os": "ContextMenu.module__group___cy14N3",
  "_0": "ContextMenu.module__selectableSection___cy14N3",
  "dl": "ContextMenu.module__checkboxItem___cy14N3",
  "fb": "ContextMenu.module__checkboxIndicator___cy14N3",
  "kv": "ContextMenu.module__checkbox___cy14N3",
  "xY": "ContextMenu.module__checkboxChecked___cy14N3",
  "AM": "ContextMenu.module__groupLabel___cy14N3",
  "HG": "ContextMenu.module__submenuPopover___cy14N3",
  "a": "ContextMenu.module__submenuScroller___cy14N3",
  "pT": "ContextMenu.module__quickReactionsGroup___cy14N3",
  "gV": "ContextMenu.module__quickReactionItem___cy14N3",
  "z5": "ContextMenu.module__quickReactionShortcut___cy14N3",
  "dd": "ContextMenu.module__quickReactionTooltipContent___cy14N3",
  "Vx": "ContextMenu.module__quickReactionTooltipHint___cy14N3",
  "hH": "ContextMenu.module__emojiSubmenuIcon___cy14N3",
  "XN": "ContextMenu.module__emojiSubmenuImg___cy14N3",
  "S8": "ContextMenu.module__menuEnter___cy14N3",
};

module.exports = exports;
